export default __webpack_public_path__ + "static/media/Beehaz_12_live_chat.e2d2469f.png";